const resolveTarget = (target) => {
  if (target) return target;
  if (typeof window !== 'undefined') return window;
  return {};
};

export const loadRuntimeConfig = async ({
  fetchFn = fetch,
  target = undefined,
  configPath = '/config.json',
} = {}) => {
  const runtimeTarget = resolveTarget(target);

  try {
    const response = await fetchFn(configPath, { cache: 'no-store' });

    if (!response.ok) {
      console.warn('Runtime config not found, using build-time defaults.');
      return false;
    }

    runtimeTarget.__APP_CONFIG__ = await response.json();
    return true;
  } catch {
    console.warn('Failed to load runtime config, using build-time defaults.');
    return false;
  }
};
